import { get, post } from '../index'
import session from '@/auth/session'

export default {
  // BANKIA - FIRMA Y TERMINOS Y CONDICIONES
  signin: (body) => {
    return new Promise((resolve, reject) => {
      post('sign', body)
      .then((res) => {
        session.replace(res.data)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  terms: (params) => get('terms', params)
}
